interface TCheck {
  value: number
  min?: number | string | undefined
  max?: number | string | undefined
}

export const checkValue = ({ value, min, max }: TCheck) => {
  if (min !== undefined && value < +min) {
    return `${min}`
  } else if (max !== undefined && value > +max) {
    return `${max}`
  }

  return `${value}`
}
